import Api from './Api';

class LogicBaseUserApi extends Api {
  url = 'logicbaseusers';
}

const singleton = new LogicBaseUserApi();
export default singleton;
